import { Checkbox, Tooltip } from '@mm/components';
import { emojis } from '@mm/constants/emojis/emojis';
import classnames from 'classnames';
import React from 'react';
import styles from './EmojiList.module.css';

type Props = {
  selectedEmojis: Set<string>;
  invalidEmojis: string[];
  setSelectedEmojis: (emojis: Set<string>) => void;
  tooltipText: string;
  containerClassname?: string;
  emojiCheckboxClassname?: string;
  isMM?: boolean;
  disabled?: boolean;
};

export const EmojiList = (props: Props) => {
  const {
    setSelectedEmojis,
    selectedEmojis,
    invalidEmojis,
    tooltipText,
    isMM,
    disabled,
    containerClassname,
    emojiCheckboxClassname,
  } = props;

  const setEmoji = (emoji: string) => {
    if (selectedEmojis.has(emoji)) {
      setSelectedEmojis(new Set([...selectedEmojis].filter(v => v !== emoji)));
      return;
    }
    setSelectedEmojis(new Set([...selectedEmojis, emoji]));
  };

  return (
    <span
      className={classnames(styles.emojisContainer, containerClassname, {
        [styles.emojisContainerMM]: isMM,
      })}
    >
      {Object.keys(emojis).map(currEmoji => {
        const invalid = invalidEmojis.includes(currEmoji);
        return (
          <Checkbox
            key={currEmoji}
            className={classnames(
              styles.emojiCheckbox,
              emojiCheckboxClassname,
              {
                [styles.emojiCheckboxDisabled]: invalid || disabled,
              },
            )}
            labelClassName={styles.emojiCheckboxLabel}
            isChecked={selectedEmojis.has(currEmoji)}
            onToggle={() => setEmoji(currEmoji)}
            disabled={invalid || disabled}
            label={
              invalid && !disabled ? (
                <Tooltip title={tooltipText}>
                  <img
                    className={styles.emojiDisabled}
                    src={emojis[currEmoji]}
                  />
                </Tooltip>
              ) : (
                <>
                  <img
                    className={classnames(styles.emoji, {
                      [styles.emojiDisabled]: disabled,
                    })}
                    src={emojis[currEmoji]}
                  />
                </>
              )
            }
          />
        );
      })}
    </span>
  );
};
